import request from '@/util/request'

// 获取活动详情
export function getActivityDetail(teacherId) {
  return request({
    url: `/courseTeachers/getCourseByTeacherId/`+teacherId,
    method: 'get',
    headers: { "Content-Type": "application/json" },
  })
}

// 查询课程报名的学员
export function getCollegeByCourseId(userId) {
  return request({
    url: `/courseEnrollments/getCollegeByCourseId/`+userId,
    method: 'get',
    headers: { "Content-Type": "application/json" },
  })
}

// 查询课程的教师
export function getTeacherByCourseId(courseId) {
  return request({
    url: `/courseTeachers/getTeacherByCourseId/`+courseId,
    method: 'get',
    headers: { "Content-Type": "application/json" },
  })
}

// 根据课程ID查询课程详情
export function getCourseById(courseId) {
  return request({
    url: `/courseTeachers/getCourseById/`+courseId,
    method: 'get',
    headers: { "Content-Type": "application/json" },
  })
}

// 创建课程报名（需登录）
export function createEnrollment(courseId, paidAmount) {
  return request({
    url: `/courseEnrollments/createEnrollment`,
    method: 'post',
    data: { courseId, paidAmount },
    headers: { "Content-Type": "application/json" },
  })
}
